import { transformOfferEvent } from '@core/mappers/offer/transformOfferEvent';
import { SuperOfferDto } from '@core/mappers/offer/dtos/SuperOfferDto';
import SuperOffer from '@core/models/offer/SuperOffer';

export function transformSuperOffer(dto: SuperOfferDto): SuperOffer {
    const superOffer = new SuperOffer();
    Object.entries(dto).forEach(([key, events]) => {
        superOffer[key] = events.map(transformOfferEvent);
    });
    return superOffer;
}
